// ================================
// STAFF LOGIN
// ================================
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export function StaffLogin() {
  const [username, setUsername] = useState('');
  const [pin, setPin]       = useState('');
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const { loginStaff }      = useAuth();
  const navigate            = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await loginStaff(username, pin);
      navigate('/staff/dashboard');
    } catch (err) {
      setError('Invalid username or PIN');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        width: 340, background: '#06091a',
        border: '1px solid #0a1628', borderRadius: 20, padding: 36
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            width: 60, height: 60, borderRadius: '50%',
            background: 'linear-gradient(135deg,#0d1b3e,#1a0a0a)',
            border: '2px solid #1e6bff',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 12px'
          }}>
            <span style={{ fontFamily: 'Bebas Neue,sans-serif', fontSize: 28, color: '#c0101a' }}>W</span>
          </div>
          <h2 style={{ fontFamily: 'Bebas Neue,sans-serif', fontSize: 24, letterSpacing: 3, color: '#e8e8e8' }}>
            Staff Portal
          </h2>
          <p style={{ fontSize: 12, color: '#3a5a8a', marginTop: 4 }}>Weedo World</p>
        </div>
        <form onSubmit={handleLogin}>
          <div className="field">
            <label>Username</label>
            <input type="text" placeholder="Your username"
              value={username} onChange={e => setUsername(e.target.value)} required />
          </div>
          <div className="field">
            <label>PIN</label>
            <input type="password" placeholder="••••" maxLength={6}
              value={pin} onChange={e => setPin(e.target.value)} required />
          </div>
          {error && <p style={{ color: '#c0101a', fontSize: 13, marginBottom: 12 }}>{error}</p>}
          <button className="btn-primary" type="submit" disabled={loading} style={{ marginTop: 8 }}>
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 12 }}>
          <span style={{ color: '#1e6bff', cursor: 'pointer' }} onClick={() => navigate('/staff/activate')}>
            First time? Activate your PIN
          </span>
        </p>
        <p style={{ textAlign: 'center', marginTop: 10, fontSize: 12 }}>
          <span style={{ color: '#3a5a8a', cursor: 'pointer' }} onClick={() => navigate('/')}>
            ← Back to app
          </span>
        </p>
      </div>
    </div>
  );
}

export default StaffLogin;
